// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { baseUrl } from './../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getReviewsNotDone = createAsyncThunk(
  'reports/reviewsNotDone',
  async (params) => {
    const response = await axios.get(
      baseUrl() + '/dashboard/reviews/not-done',
      { params }
    )
    return {
      allReviewsAllDone: response.data.data,
      totalPages: response?.data?.count?.total
    }
  }
)

export const getReviewsNotDoneReminders = createAsyncThunk(
  'reviews/getReviewsNotDoneReminders',
  async () => {
    const response = await axios.get(
      baseUrl() + '/mailconfiguration/review-reminders'
    )
    return {
      reviewReminders: response.data?.data || []
    }
  }
)

export const addReviewsNotDoneReminder = createAsyncThunk(
  'reviews/addReviewsNotDoneReminder',
  async (
    { technologyId, toEmail },
    { dispatch }
  ) => {
    try {
      const res = await axios.post(baseUrl() + '/mailconfiguration/review-reminders', {
        technologyId,
        toEmail
      })
      toast.success(res?.data?.message)
      await dispatch(getReviewsNotDoneReminders())
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.response?.data?.errorMessage || "Something Went Wrong")
      return false
    }
  }
)

export const updateReviewsNotDoneReminder = createAsyncThunk(
  'reviews/updateReviewsNotDoneReminder',
  async (
    { technologyId, toEmail, id },
    { dispatch }
  ) => {
    try {
      const res = await axios.put(baseUrl() + '/mailconfiguration/review-reminders/' + id, {
        technologyId,
        toEmail
      })
      toast.success(res?.data?.message)
      await dispatch(getReviewsNotDoneReminders())
      return true
    } catch (error) {
      toast.error(error?.response?.data?.message)
      return false
    }
  }
)

export const deleteReviewsNotDoneReminder = createAsyncThunk(
  'reviews/deleteReviewsNotDoneReminder',
  async ({ id }, { dispatch }) => {
    try {
      const res = await axios.delete(baseUrl() + '/mailconfiguration/review-reminders/' + id)
      toast.success(res?.data?.message)
      await dispatch(getReviewsNotDoneReminders())
      return id
    } catch (error) {
      toast.error(error?.response?.data?.message)
    }
  }
)

export const ReviewsNotDoneSlice = createSlice({
  name: 'reviewsNotDoneMaster',
  initialState: {
    allReviewsAllDone: [],
    reviewReminders : [],
    selectReviewReminder : {},
    loader: false,
    params: {
      pageNo: 1,
      pageSize: 25,
      userStatus: "0,1,2,3,5"
    },
    totalPages: 0,
    filterData: { userStatus: "0,1,2,3,5" },
    clearFilter: true

  },
  reducers: {
    setParams: (state, action) => {
      state.params = {
        // ...state.params,
        ...action.payload
      }
    },
    setSelectReviewReminder: (state, action) => {
      if (action.payload === null) {
        state.selectReviewReminder = null
      } else {
        state.selectReviewReminder = action.payload
      }
    },
    setPageNo: (state, action) => {
      state.params.pageNo = action.payload
    },
    setPageSize: (state, action) => {
      state.params.pageSize = action.payload
    },
    setFilterData: (state, action) => {
      if (action.payload === null) {
        state.filterData = null
      } else {
        state.filterData = action.payload
      }
    },
    selectClearFilter: (state, action) => {
      state.clearFilter = action.payload
    },
    setLoader: (state, action) => {
      state.loader = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReviewsNotDone.fulfilled, (state, action) => {
        ; (state.loader = false),
          (state.allReviewsAllDone = action.payload.allReviewsAllDone)
        state.totalPages = action.payload.totalPages
      })
      .addCase(getReviewsNotDone.pending, (state, action) => {
        state.loader = true
      })
      .addCase(getReviewsNotDone.rejected, (state, action) => {
        state.loader = false
      })
      .addCase(getReviewsNotDoneReminders.fulfilled, (state, action) => {
        state.loader = false
        state.reviewReminders = action.payload.reviewReminders
      })
      .addCase(getReviewsNotDoneReminders.pending, (state, action) => {
        state.loader = true
      })
      .addCase(getReviewsNotDoneReminders.rejected, (state, action) => {
        state.loader = false
      })
  }
})

export const {
  setParams,
  setSelectReviewReminder,
  setPageNo,
  setPageSize,
  setFilterData,
  selectClearFilter,
  setLoader
} = ReviewsNotDoneSlice.actions

export default ReviewsNotDoneSlice.reducer
